<ng-template
  let-extraClass="extraClass"
  #topNav
>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Change Max Drive?'">
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>

    <tidy-row [align]="'center'">
      <tidy-text
        [body]="'By reducing your max estimated drive time, you will immediately cancel all these clients who are outside your new max. You may not be able to get clients back. '">
      </tidy-text>
      <tidy-text
      [helper]="'Learn More'"
      (action)="learnMoreTravelTime()">
    </tidy-text>
    </tidy-row>

    <tidy-card>
      <tidy-row class="extra-bottom-padding">
        <tidy-text
          [header]="'Cancelled Cleanings'">
        </tidy-text>
      </tidy-row>
      <ng-container *ngFor="let cancellation of cancellations; last as isLast">

        <tidy-row>
          <tidy-grid>
            <ion-row>
              <ion-col size="5">
                <tidy-text
                  [body]="cancellation?.time | ttime">
                </tidy-text><br>
                <tidy-text
                  [body]="cancellation?.type | tidyCleaningType">
                </tidy-text>
              </ion-col>
              <ion-col size="7" >
                <tidy-text
                  [body]="cancellation.date | formatDateTimePipe: 'LLL d'">
                </tidy-text><br>
                <tidy-text
                  style="color:#AC6D67"
                  body="{{cancellation.performance | performanceText}}: {{cancellation.fee | tcurrency}}">
                </tidy-text>
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-row>

        <tidy-row *ngIf="!isLast">
          <tidy-divider></tidy-divider>
        </tidy-row>

      </ng-container>
    </tidy-card>

    <tidy-row [align]="'center'">
      <tidy-text
        [body]="('Change max drive time to ' | translate) + travelTime + (' minutes?  Your work area will now change.' | translate)">
      </tidy-text>
    </tidy-row>

    <tidy-error-message
      [text]="errorMessage">
    </tidy-error-message>

    <tidy-two-column-row>
      <tidy-button item-left
        [text]="'Go Back'"
        [action]="goBack.bind(this)"
        class="secondary">
      </tidy-button>
      <tidy-button item-right
        [text]="'Confirm'"
        [action]="confirmUpdate.bind(this)"
        class="secondary">
      </tidy-button>
    </tidy-two-column-row>

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>
